import { useCallback } from 'react'

export interface WebShareProps {
  title: string
  text: string
  url: string
}

export const useWebShare = () => {
  //TODO: create fallback for unsupported browserinos
  //TODO: possible fallback: https://www.npmjs.com/package/react-share

  if (typeof window === 'undefined') {
    return { canShare: false }
  }

  const navigator = window.navigator as any
  const canShare = !!navigator.canShare

  // just use the fallback package mentioned above...
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const share = useCallback(
    async (props: WebShareProps) => {
      if (!canShare) {
        console.warn('webshare api is not supported')
        return
      }
      try {
        navigator.share(props)
        return true
      } catch (error) {
        console.warn(error)
        return false
      }
    },
    [navigator, canShare]
  )

  return { canShare, share }
}
